import { apiClient } from './client';
import { RoleDefinitionDto } from '../types';

export const rolesApi = {
  list(): Promise<RoleDefinitionDto[]> {
    return apiClient.get<RoleDefinitionDto[]>('/api/roles');
  },
};
